import React from 'react'

export default function DashHome() {
  return (
    <div className='bg-white h-full text-black flex justify-center items-center'>
        <h1 className='font-bold'>Home Tab</h1>
    </div>
  )
}
